import React from "react";
import MCSGrid from "./MCSGrid";

const MCSGridRevert = (props) => {
    let className = "revert-min-width" + (props.className ? " " + props.className : "");
    return <MCSGrid
        className={className}
        type={props.type}>
        {props.children}
    </MCSGrid>
};

export default MCSGridRevert;
